import React, { useEffect } from "react"
import { useLocation } from "@reach/router"
import Header from "./Header"
import Footer from "./Footer"
import "../assets/style.css"

const Layout = ({ children, hideFooter = false }) => {
  const slugLocation = useLocation()

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-show")

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 }
    )

    elements.forEach(el => observer.observe(el))

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div className="layout-container">
      <Header />
      <div>{children}</div>
      {!hideFooter && <Footer />}
    </div>
  )
}

export default Layout
